// extracted by mini-css-extract-plugin
export default {"wrapper":"SWOTModelSidebar_wrapper__l3uUF","btn":"SWOTModelSidebar_btn__GnYsJ","current":"SWOTModelSidebar_current__LJCsb","imgWrap":"SWOTModelSidebar_imgWrap__kHo2D"};